var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookmark"},[_c('b-img',{staticClass:"bookmark-icon",attrs:{"src":"/images/webinars/bookmark.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }